/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/* eslint-disable no-unused-vars */
enum ERROR_FIELD {
  ORIGIN_FIELD,
  DESTINATION_FIELD,
}
export default ERROR_FIELD;
/* eslint-enable no-unused-vars */
